import React from "react";
import { Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import CustomTooltip from "../Tooltip";

const Index = ({ title, style = {}, ...other }) => {
  const { t } = useTranslation(["configure"]);

  return (
    <CustomTooltip title={title || t("Add")}>
      <Button
        type="button"
        color="primary"
        style={{ padding: 5, ...style }}
        {...other}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.89999 0C7.28416 0.0315594 4.78435 1.08472 2.93454 2.93454C1.08472 4.78435 0.0315594 7.28416 0 9.9C0.0315594 12.5158 1.08472 15.0156 2.93454 16.8655C4.78435 18.7153 7.28416 19.7684 9.89999 19.8C12.5158 19.7684 15.0156 18.7153 16.8655 16.8655C18.7153 15.0156 19.7684 12.5158 19.8 9.9C19.7684 7.28416 18.7153 4.78435 16.8655 2.93454C15.0156 1.08472 12.5158 0.0315594 9.89999 0ZM15.5571 10.6071H10.6071V15.5571H9.19285V10.6071H4.24286V9.19286H9.19285V4.24286H10.6071V9.19286H15.5571V10.6071Z"
            fill="white"
          />
        </svg>
      </Button>
    </CustomTooltip>
  );
};

export default Index;
